import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LogOut, User } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
import { getUserProfile,getUserAddresses,updateAddress,deleteAddress,getUserOrders  } from '../services/userService';
import AddressModal from '../Context/AddressModal';
const AccountPage = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { isLoggedIn } = useAuth();

  const [userInfo, setUserInfo] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login');
    } else {
      const fetchData = async () => {
        try {
          const profile = await getUserProfile();
          setUserInfo(profile);
  
          const addressData = await getUserAddresses();
          setAddresses(addressData);
        } catch (error) {
          console.error('Veriler alınamadı:', error);
        }
      };
  
      fetchData();
    }
  }, [isLoggedIn, navigate]);
  
  const openModal = (address) => {
    setSelectedAddress(address);
    setIsModalOpen(true);
  };
  
  // modal kapama
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedAddress(null);
  };
  
  const handleUpdateAddress = async (data) => {
    try {
      const payload = {
        id: data.id, // adresin ID'si
        title: data.title,
        state: data.state,
        address: data.address,
        is_same_as_delivery: data.is_same_as_delivery,
        billingName: data.full_name,
        billingDistrict: data.district,
        billingAddress: data.billing_address,
        taxOffice: data.tax_office,
        taxNumber: data.tax_number,
      };
  
      await updateAddress(payload); // backend'e doğru formatta veri gönderiliyor
      closeModal();
  
      const updated = await getUserAddresses();
      setAddresses(updated);
    } catch (err) {
      console.error("Güncelleme hatası", err);
    }
  };
  

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const ordersData = await getUserOrders(); // Sipariş verilerini alıyoruz
        setOrders(ordersData); // State'e kaydediyoruz

      } catch (err) {
        console.error("Siparişler alınırken bir hata oluştu.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders(); // Siparişleri çağırıyoruz
  }, []);
  
  
  
  const handleDeleteAddress = async (id) => {
    try {
      await deleteAddress(id);
      closeModal();
      const updated = await getUserAddresses();
      setAddresses(updated);
    } catch (err) {
      console.error("Silme hatası", err);
    }
  };
  

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (!isLoggedIn) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-secondary-light py-12"
    >
      <div className="container-custom">
        <div className="bg-white rounded-lg shadow-medium p-8">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-2xl font-bold text-gray-dark">Hesabım</h1>
            <button
              onClick={handleLogout}
              className="flex items-center text-gray-dark hover:text-primary transition-colors"
            >
              <LogOut size={20} className="mr-2" />
              Çıkış Yap
            </button>
          </div>

          <div className="flex items-center mb-8 p-6 bg-secondary-light rounded-lg">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mr-6">
              <User size={32} className="text-primary" />
            </div>
            <div>
            <h2 className="text-xl font-semibold text-gray-dark">
  {userInfo ? `${userInfo.first_name} ${userInfo.last_name}` : 'Kullanıcı Adı'}
</h2>
              <p className="text-gray">{userInfo?.email || 'E-posta adresi'}</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-6 border rounded-lg">
  <h3 className="text-lg font-semibold mb-4">Siparişlerim</h3>
  {orders.length === 0 ? (
    <p className="text-gray">Henüz sipariş bulunmuyor.</p>
  ) : (
    <ul className="max-h-64 overflow-y-auto"> {/* Kaydırılabilir alan */}
      {orders.map((order) => (
        <li key={order.id} className="mb-4">
          <div 
            className={`border p-4 rounded-md 
              ${order.status === 1 ? 'bg-yellow-100' : ''}   {/* Onay Bekliyor - Sarı */}
              ${order.status === 2 ? 'bg-blue-100' : ''}     {/* Hazırlanıyor - Mavi */}
              ${order.status === 3 ? 'bg-green-100' : ''}    {/* Teslim Edildi - Yeşil */}
            `}
          >
            <h4 className="text-lg font-medium">{order.title}</h4>
            <p>{order.description}</p>
            <p><strong>Tarih:</strong> {new Date(order.order_date).toLocaleDateString("tr-TR")}</p>
            <p><strong>Fiyat:</strong> {order.total_price} TL</p>
            
            {/* Sipariş durumu */}
            <p>
              <strong>Status:</strong> 
              {order.status === 1 && 'Onay Bekliyor'}
              {order.status === 2 && 'Hazırlanıyor'}
              {order.status === 3 && 'Teslim Edildi'}
            </p>
          </div>
        </li>
      ))}
    </ul>
  )}
</div>



            <div className="p-6 border rounded-lg">
  <h3 className="text-lg font-semibold mb-4">Adreslerim</h3>
  {addresses.length === 0 ? (
    <p className="text-gray">Henüz kayıtlı adres bulunmuyor.</p>
  ) : (
    <div className="max-h-64 overflow-y-auto space-y-4 pr-2">
      {addresses.map((address, index) => (
        <div
          key={index}
          onClick={() => openModal(address)}
          className="cursor-pointer p-4 rounded-md border hover:shadow-md transition-shadow bg-secondary hover:bg-primary"
        >
          <p className="font-semibold text-gray-dark mb-1">{address.title || 'Adres Başlığı'}</p>
          <p className="text-sm text-gray">{address.full_address}</p>
        </div>
      ))}
    </div>
  )}
</div>
          </div>
        </div>
      </div>
      <AddressModal
  open={isModalOpen}
  onClose={closeModal}
  address={selectedAddress}
  onUpdate={handleUpdateAddress}
  onDelete={handleDeleteAddress}
/>

    </motion.div>
  );
};

export default AccountPage;
